import Main from './Main';
import Audio from './Audio';

export default {
    Main,
    Audio
}